export function lochelper(i18n)
{
    const oldFormatter = i18n._formatter;
    i18n._formatter = {
        interpolate: (message, values) => {
            let msg = oldFormatter.interpolate(message, values).join('');
            return [msg.replace(/(a)\((z)\)( +)(.)/gi, (full, a, z, ws, letter) => letter.match(/[üóőúéáűuioeaí]/i) ? `${a}${z}${ws}${letter}` : `${a}${ws}${letter}`)];
        }
    }
}
